// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
import Label from 'src/components/label';
import { getUserFromLocalStorage } from 'src/utils/consts';
// ----------------------------------------------------------------------

export default function NavUpgrade() {
  const user = getUserFromLocalStorage();

  const { t } = useLocales();

  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center">
        <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2 }}>
          <Typography variant="subtitle2" noWrap>
            Hi, {user?.name}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
            Need help?
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
            Please email
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
          itrequests@hcterminal.com

          </Typography>
        </Stack>

      </Stack>
    </Stack>
  );
}
